import { getConfig, setLevel, onLevelChange, LogLevel, type LogLevelConfig } from '@core/logging/logLevelManager';
import { Select } from '@soteria/design-system-ve';
import { useEffect, useState } from 'react';

import { settingsOptionContainer, settingsOptionLabel, selectContainer } from './SettingsDialog.css';

interface SystemTabProps {
  className?: string;
}

const LOG_LEVEL_OPTIONS = [
  { value: LogLevel.ERROR, label: 'Error' },
  { value: LogLevel.WARN, label: 'Warning' },
  { value: LogLevel.INFO, label: 'Info' },
  { value: LogLevel.DEBUG, label: 'Debug' },
  { value: LogLevel.TRACE, label: 'Trace' },
];

export function SystemTab({ className }: SystemTabProps) {
  const [config, setConfig] = useState<LogLevelConfig>(getConfig());

  useEffect(() => {
    // Subscribe to log level changes
    const unsubscribe = onLevelChange(newConfig => {
      setConfig(newConfig);
    });

    return unsubscribe;
  }, []);

  const handleLevelChange = (value: string) => {
    const level = value as LogLevel;

    setLevel(level);
  };

  return (
    <div key="system" className={className}>
      {/* Log Level selection */}
      <div className={settingsOptionContainer}>
        <div className={settingsOptionLabel}>Log Level</div>
        <div className={selectContainer}>
          <Select options={LOG_LEVEL_OPTIONS} value={config.level.toString()} onChange={handleLevelChange} />
        </div>
      </div>
      {/* Log Level source */}
      <div className={settingsOptionContainer}>
        <div className={settingsOptionLabel}>Log Level Source</div>
        <div className={settingsOptionLabel}>{config.source}</div>
      </div>
      {/* Version */}
      <div className={settingsOptionContainer}>
        <div className={settingsOptionLabel}>Version</div>
        <div className={settingsOptionLabel}>{import.meta.env.VITE_APP_VERSION || 'unknown'}</div>
      </div>
    </div>
  );
}
